module.exports = __webpack_public_path__ + "img/Municipality_Tel_Aviv.ccc8496d.svg";